
declare global {
  interface Window {
    Module?: {
      onRuntimeInitialized?: () => void;
    };
  }
}

export {}; // Ensure this file is treated as a module
